import { mapActions, mapGetters } from 'vuex';

const BaseControlMixin = {
  props: {
    vars: {
      required: true,
      type: Array,
    },
    statusVar: {
      required: false,
      type: Object,
    },
  },
  computed: {
    ...mapGetters('app', [
      'isConnectionOk',
    ]),
    getSingleVar() {
      return this.vars[0];
    },
    getStatusVar() {
      // for control actor it will be statusVar passed by props, but for scenes it will be
      // single var, because scenes has only one var, not control -> status vars
      return this.statusVar || this.getSingleVar;
    },
    validation() {
      let { validation } = this.getSingleVar;
      if (typeof validation === 'string') {
        validation = JSON.parse(this.getSingleVar.validation);
      }
      return validation;
    },
  },
  methods: {
    ...mapActions([
      'setVarsValue',
    ]),
    handleControl(value) {
      this.setVarsValue({ varItem: this.getSingleVar, value });
    },
  },
};

export default BaseControlMixin;
